import React from "react";
import DataRequestsComponent from "../../../components/Admin/DataRequests";

export default function AdminDataRequestsPage() {
    return <DataRequestsComponent />;
}
